import { HeadCell } from '@shared';
export * from './common';

type userColumnIds =
  | 'partnerUuid'
  | 'name'
  | 'email'
  | 'course'
  | 'exam'
  | 'timeStart'
  | 'timeEnd'
  | 'examDuration'
  | 'status'
  | 'action';

type courseColumnIds = 'partnerUuid' | 'course' | 'availableExams' | 'courseUsers' | 'action';

type examColumnIds =
  | 'partnerUuid'
  | 'partner'
  | 'course'
  | 'exam'
  | 'sessions'
  | 'proctoring'
  | 'startDate'
  | 'endDate'
  | 'action';

type auditColumnIds =
  | 'partner'
  | 'name'
  | 'email'
  | 'course'
  | 'exam'
  | 'startTime'
  | 'endTime'
  | 'duration'
  | 'auditStatus'
  | 'action';

export const userColumns: readonly HeadCell<userColumnIds>[] = [
  { id: 'partnerUuid', label: 'Partner' },
  { id: 'name', label: 'Name' },
  { id: 'email', label: 'Email' },
  { id: 'course', label: 'Course' },
  { id: 'exam', label: 'Exam' },
  { id: 'timeStart', label: 'Exam Start' },
  { id: 'timeEnd', label: 'Exam End' },
  { id: 'examDuration', label: 'Duration' },
  { id: 'status', label: 'Session Status' },
  { id: 'action', label: '' },
];

export const courseColumns: readonly HeadCell<courseColumnIds>[] = [
  { id: 'partnerUuid', label: 'Partner' },
  { id: 'course', label: 'Course' },
  { id: 'availableExams', label: 'Available Exams' },
  { id: 'courseUsers', label: 'Course Users' },
  { id: 'action', label: '' },
];

export const examColumns: readonly HeadCell<examColumnIds>[] = [
  { id: 'partnerUuid', label: 'Partner' },
  { id: 'course', label: 'Course' },
  { id: 'exam', label: 'Exam' },
  { id: 'sessions', label: 'Sessions' },
  { id: 'proctoring', label: 'Proctoring' },
  { id: 'startDate', label: 'Start Date' },
  { id: 'endDate', label: 'End Date' },
  { id: 'action', label: '' },
];

export const auditColumns: readonly HeadCell<auditColumnIds>[] = [
  { id: 'partner', label: 'Partner' },
  { id: 'name', label: 'Name' },
  { id: 'email', label: 'Email' },
  { id: 'course', label: 'Course' },
  { id: 'exam', label: 'Exam' },
  { id: 'startTime', label: 'Exam Start Time' },
  { id: 'endTime', label: 'Exam End Time' },
  { id: 'duration', label: 'Duration' },
  { id: 'auditStatus', label: 'Audit Status' },
  { id: 'action', label: '' },
];

export type TUser = {
  uuid: string;
  name: string;
  email: string;
  course: string;
  exam: string;
  timeStart: string;
  timeEnd: string;
  examDuration: string;
  status: string;
};

export type TCourse = {
  uuid: string;
  course: string;
  availableExams: string;
  courseUsers: string;
};

export type TExam = {
  uuid: string;
  course: string;
  exam: string;
  sessions: string;
  proctoring: string;
  startDate: string;
  endDate: string;
};
